<template>
  <div class="visa">
    <ld-navbar
      class="header"
      @click-left="$router.push('/home')"
    >
      <van-search
        placeholder="签证国家/地区"
        v-model.lazy="visaSearchInfo.country"
        readonly
        @click="$refs['nation'].toggle()"
      >
        <div
          slot="label"
          @click.stop="consularShow = true"
        >
          {{ visaSearchInfo.consularDistrictName }}
          <van-icon
            class="vertical-middle"
            name="arrow-down"
          />
        </div>
      </van-search>
    </ld-navbar>

    <div class="my-swipe">
      <trip-type />
      <van-swipe
        :loop="false"
        :autoplay="3000"
        height="180"
      >
        <van-swipe-item
          v-for="(country, index) in countryImages"
          @click="nationSelect(country)"
          :key="index"
        >
          <img
            width="100%"
            v-lazy="country.src"
          >
          <p class="name">
            {{ country.cname }}
          </p>
        </van-swipe-item>
      </van-swipe>
    </div>

    <van-collapse
      v-model="activeName"
      @change="change"
      class="visaCollapse"
      accordion
    >
      <van-collapse-item
        v-for="(continen, i) in continentList"
        :key="continen.continentId"
        :title="continen.continentName"
        :name="i"
      >
        <van-grid>
          <van-grid-item
            v-for="country in continen.hotCountrys"
            :key="country.id"
            @click="nationSelect(country)"
          >
            <van-image
              class="van-grid-item__icon"
              :src="country.countryFlagUrl"
            />
            <span class="van-grid-item__text">{{ country.cname }}</span>
          </van-grid-item>
        </van-grid>
      </van-collapse-item>
    </van-collapse>

    <ld-nation
      ref="nation"
      @selected="nationSelect"
    />

    <van-popup
      v-model="consularShow"
      class="full-height full-width consular-list"
      :close-on-popstate="true"
      position="right"
    >
      <ld-header @click-left="consularShow = false">
        选择办理地点
      </ld-header>
      <van-cell-group>
        <van-cell
          v-for="(consular, index) in visaSearchInfo.ConsularList"
          v-show="consular.id"
          :key="index"
          :title="consular.distName"
          clickable
          @click="consularSelect(consular)"
        />
      </van-cell-group>
    </van-popup>
  </div>
</template>

<script>
import { Swipe, SwipeItem, Search, Collapse, CollapseItem, Grid, GridItem, Popup, Cell, CellGroup, Image } from 'vant'
import { mapGetters } from 'vuex'

import tripType from 'Common/tripType'
import ldNavbar from 'Common/ldNavbar'
import ldNation from 'Components/ldNation'
import VisaBookInterator from 'Domain/use-cases/visa-book-interactor'

const CPLX = $dict.PRO_TYPE.visa

export default {
  name: 'Visa',
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Search.name]: Search,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Popup.name]: Popup,
    [Cell.name]: Cell,
    [Image.name]: Image,
    [CellGroup.name]: CellGroup,
    ldNavbar, ldNation, tripType
  },
  data () {
    return {
      value: '',
      activeName: '',
      consularShow: false,
      showSearch: false,
      continentList: [],
      countryImages: [
        { id: '0003002', cname: '美国', src: 'https://image.baidu.com/search/down?tn=download&ipn=dwnl&word=download&ie=utf8&fr=result&url=http%3A%2F%2Fi1.sinaimg.cn%2Ftravel%2F2013%2F0717%2FU9743P704DT20130717105322.jpg&thumburl=https%3A%2F%2Fss1.bdstatic.com%2F70cFuXSh_Q1YnxGkpoWK1HF6hhy%2Fit%2Fu%3D3854612940%2C1116008937%26fm%3D26%26gp%3D0.jpg' },
        { id: '0001027', cname: '日本', src: 'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=2167270945,4136517622&fm=26&gp=0.jpg' },
        { id: '0001031', cname: '泰国', src: 'https://image.baidu.com/search/down?tn=download&ipn=dwnl&word=download&ie=utf8&fr=result&url=http%3A%2F%2F5b0988e595225.cdn.sohucs.com%2Fimages%2F20180824%2Fa77693397c464e55bf49642263295523.jpeg&thumburl=https%3A%2F%2Fss3.bdstatic.com%2F70cFv8Sh_Q1YnxGkpoWK1HF6hhy%2Fit%2Fu%3D2418615990%2C365992983%26fm%3D26%26gp%3D0.jpg' },
      ]
    }
  },
  async created () {
    this.$store.commit('SET_SERVICE', { cplx: CPLX })
    this.$store.commit('visa/CLEAR_VISASEARCHINFO')
    
    await this.$store.dispatch('visa/getConsularList')
    this.consularSelect(this.visaSearchInfo.ConsularList[0])
  },
  async mounted () {
    // 开启默认为自己订票参数
    if (this.serviceCtrl.isDefaultName) {
      this.travelerList.push({...this.userInfo.empInfo, clkFlag: 2})
    }
    
    const { data } = await VisaBookInterator.getContinentList()
    this.continentList = data
    this.initCollapse(this.continentList.length)
  },
  methods: {
    initCollapse (i) { // 默认展开折叠面板一列内容
      this.activeName = i
      if (i < 0) return
      this.$nextTick(() => {
        this.initCollapse(--i)
      })
    },
    /**
     * 国籍选择回调
     */
    nationSelect(city) {
      this.visaSearchInfo.country = city.cname || city.cName
      this.visaSearchInfo.countryId = city.id
      this.visaSearchInfo.tripType = this.tripType
      this.$router.push('/visa/list')
    },
    consularSelect (consular) {
      consular.checked = true
      this.visaSearchInfo.consularDistrictName = consular.distName
      this.visaSearchInfo.consularDistId = consular.id
      this.consularShow = false
    },
    change(i) {
      this.continentList[i].hotCountrys = this.continentList[i].hotCountrys.concat(
        this.continentList[i].countryList.filter(c => c.isHot === 0)
      )
    }
  },
  computed: {
    ...mapGetters({
      visaSearchInfo: 'visa/visaSearchInfo',
      travelerList: 'visa/travelerList',
      tripType: 'tripType',
      userInfo: 'userInfo',
      serviceCtrl: 'serviceCtrl',
    })
  }
}
</script>

<style lang="less">
.visa {
  padding: 54px 0 30px;

  .header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
  }
  
  .visaCollapse {
    .van-collapse-item {
      .van-collapse-item__wrapper {
        min-height: 1.65rem !important;
        display: block !important;

        .van-collapse-item__content {
          padding: 0;
        }
      }
    }

    .van-grid-item {
      .van-grid-item__content {
        padding: 2px 8px;
      }
    }
  }
}

.my-swipe {
  position: relative;
  color: #fff;
  height: 180px;
  text-align: center;
  background-color: #39a9ed;

  .trip-type {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 999;
  }

  .van-swipe-item {
    position: relative;

    .name {
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      line-height: 180px;
      color: @color-text-white;
      font-size: @font-size-18;
      font-weight: bold;
      letter-spacing: 12px;
      padding-left: 12px;
    }
  }
  
}
</style>
